<template>
    <div class="flex justify-center sm:justify-end bg-white shadow-upward p-3">
        <slot />
    </div>
</template>

<script>
export default {
    //
}
</script>